import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import ImportHistory from "./ImportHistory";
import ArchivedTransactions from "./ArchivedTransactions";
import UnauthorisedAccess from "../../../UnauthorisedAccess";

const tabsKey = [
  {
    name: "Import History",
    tabName: "import-history",
    value: 1,
  },
  {
    name: "Archived Transactions",
    tabName: "archived-transactions",
    value: 2,
  },
];

const AuditTrial = ({
  selectedDateRange,
  setSelectedDateRange,
  trustId,
  isDesktop,
  readAccess,
  writeAccess,
}) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("childTab") || "import-history";

  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  return readAccess ? (
    <>
      <MainBody
        search={false}
        loading={false}
        innerBody={true}
        actionAlign={"end"}
        actionContent={""}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={"p-0 border-none"}
        >
          {activeTab === 1 ? (
            <ImportHistory trustId={trustId} isDesktop={isDesktop} />
          ) : (
            <ArchivedTransactions
              selectedDateRange={selectedDateRange}
              setSelectedDateRange={setSelectedDateRange}
              trustId={trustId}
              isDesktop={isDesktop}
            />
          )}
        </MainTabList>
      </MainBody>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default AuditTrial;
